export function uid() {
  return Math.random().toString(16).slice(-4)
}
